// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1q7yW","col":"styles_col__3KTJN","fulfillmentStatus":"styles_fulfillmentStatus__xPGGo","emailCol":"styles_emailCol__2rcK_"};